import React from "react";

const KarBharna = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-white">

      {/* Header */}
      <div className="bg-custom-orange text-white text-center py-8">
        <h1 className="text-3xl font-bold">कर भरणा</h1>
        <p className="mt-2 text-lg">QR कोड स्कॅन करून सहज कर भरा</p>
      </div>

      {/* Cards Section */}
      <div className="flex flex-wrap justify-center gap-10 mt-12 px-4">

        {/* घरपट्टी */}
        <div className="bg-white rounded-2xl shadow-lg p-6 w-72 text-center hover:scale-105 transition duration-300">
          <h2 className="text-xl font-semibold text-gray-800">घरपट्टी</h2>
          
          <img
            src="/Gharpatti.jpeg"
            alt="Gharpatti QR"
            className="w-48 h-48 mx-auto my-4"
          />
          
          <p className="text-gray-600 text-sm font-bold">
            घरपट्टी भरण्यासाठी QR scan करा
          </p>
        </div>

        {/* पाणीपट्टी */}
        <div className="bg-white rounded-2xl shadow-lg p-6 w-72 text-center hover:scale-105 transition duration-300">
          <h2 className="text-xl font-semibold text-gray-800">पाणीपट्टी</h2>
          
          <img
            src="/Panipatti.jpeg"
            alt="Panipatti QR"
            className="w-48 h-48 mx-auto my-4"
          />
          
          <p className="text-gray-600 text-sm font-bold">
            पाणीपट्टी भरण्यासाठी QR scan करा
          </p>
        </div>

      </div>

      {/* Footer Note */}
      <div className="text-center mt-12 text-gray-800 text-sm px-4 font-bold">
        <p>टीप: कृपया पेमेंट केल्यानंतर पावती जतन करून ठेवा.</p>
      </div>

    </div>
  );
};

export default KarBharna;